import { Sound } from './sound';
import { SupportedStatus } from './supportedStatus';

export class SoundCategory {
  readonly sounds: Sound[];
  readonly supported: SupportedStatus;

  readonly searchName: string;
  readonly displayName: string;
  readonly supportedSounds: Sound[];
  readonly searchable: string[];

  constructor(readonly name: string, { sounds }: any) {
    if (sounds && Array.isArray(sounds)) {
      this.sounds = sounds.map(value => new Sound(value));
      this.supported = this.sounds.some(it => !it.supported)
        ? this.sounds.every(it => !it.supported)
          ? SupportedStatus.NONE
          : SupportedStatus.PARTIAL
        : SupportedStatus.FULL;
    } else {
      this.sounds = [];
      this.supported = SupportedStatus.NONE;
    }

    this.searchName = name.split('.')
      .map(it => it.split('_').map(it => capitalize(it)).join(' '))
      .join(' > ');

    this.displayName = this.searchName.replaceAll('>', '›');

    this.supportedSounds = this.supported === SupportedStatus.FULL
      ? this.sounds
      : this.supported === SupportedStatus.NONE
        ? []
        : this.sounds.filter(it => it.supported);

    this.searchable = [this.name.toLowerCase(), this.searchName.toLowerCase(), this.displayName.toLowerCase()];
  }

  randomSound(): Sound | null {
    if (!this.supportedSounds.length) return null;
    if (this.supportedSounds.length === 1) return this.supportedSounds[0];

    const max = this.supportedSounds.reduce((a, b) => a + b.weight, 0);

    let weightLeft = Math.random() * max;
    const soundsLeft = [...this.supportedSounds];
    while (soundsLeft.length > 1 && weightLeft - soundsLeft[0].weight > 0) soundsLeft.shift();
    return soundsLeft[0];
  }

  keywordsMatches(words: string[]) {
    return words.every(sub => this.searchable.some(str => str.includes(sub)));
  }
}

function capitalize(it: string) {
  if (!it.length) return '';
  if (it.length === 1 || it === 'ui') return it.toUpperCase();
  return it[0].toUpperCase() + it.slice(1);
}
